export const CreateInferRequestTemplate = {
  "curl": `curl -X POST "\${host}/infer_request/\${service}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer \${apiKey}" \\
  --data-raw '\${input}'`,
  "javascript": `const url = "\${host}/infer_request/\${service}";

const response = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer \${apiKey}', 
  },
  body: JSON.stringify(\${input})
});

const json = await response.json();

console.log(json);`,
  "python": `import requests

url = "\${host}/infer_request/\${service}";
headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer \${apiKey}"
}
data = \${input}
  
response = requests.post(url, headers=headers, json=data)
print(response.json())`
}

export const GetInferRequestTemplate = {
  "curl": `curl -X GET "\${host}/infer_request/\${requestId}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer \${apiKey}"`,
  "javascript": `const url = "\${host}/infer_request/\${requestId}";

const response = await fetch(url, {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer \${apiKey}', 
  },
});

const json = await response.json();

console.log(json);`,
  "python": `import requests
  
url = "\${host}/infer_request/\${requestId}";
headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer \${apiKey}"
}
  
response = requests.get(url, headers=headers)
print(response.json())`
}

export const CreatePreSignedUrlsTemplate = {
  "curl": `curl -X POST "\${host}/infer_request/\${alias}/input_presigned_urls" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer \${apiKey}"`,
  "javascript": `const url = "\${host}/infer_request/\${alias}/input_presigned_urls";

const response = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer \${apiKey}', 
  },
});

const json = await response.json();

console.log(json);`,
  "python": `import requests
  
url = "\${host}/infer_request/\${alias}/input_presigned_urls";
headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer \${apiKey}"
}
  
response = requests.post(url, headers=headers)
print(response.json())`
}

export const UploadFileToBucketTemplate = {
  "curl": `# Replace $PRESIGNED_URL with the presigned_url value you get from Create Input Presigned URLs API \\
curl -X PUT "\${presignedUrl}" \\ 
  -H "Content-Type: application/octet-stream" \\
  --data-binary "\${localFilePath}"`,
  "javascript": `const fs = require('fs');
const data = fs.readFileSync('\${localFilePath}');

// Replace $PRESIGNED_URL with the presigned_url value you get from Create Input Presigned URLs API
const url = "\${presignedUrl}"; 
const response = await fetch(url, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/octet-stream',
  },
  body: data
});

if (response.ok) {
  console.log(\`Upload successful: \${response.status}\`);
} else {
  console.error(\`Upload failed: \${response.status} \${response.statusText}\`);
}`,
  "python": `import requests
  
# Replace $PRESIGNED_URL with the presigned_url value you get from Create Input Presigned URLs API
url = "\${presignedUrl}"; 
headers = {
    "Content-Type": "application/octet-stream",
}

with open("\${localFilePath}", "rb") as f:
    response = requests.put(url, headers=headers, data=f)
if response.ok:
    print(f"Upload successful: {response.status_code}")
else:
    print(f"Upload failed: {response.status_code} {response.reason}")`
}

export const Kokoro82M = {
  "name": "kokoro-82m",
  "params": [
    {
      label: "Speed",
      name: "speed",
      desc: "The speed parameter lets you fine-tune how fast or slow the output audio is spoken.",
      min: 0.5,
      max: 2,
      step: 0.1,
      default: 1,
    }
  ]
}

export const StepVideo = {
  "name": "step-video",
  "params": [
    {
      label: "FPS",
      name: "fps",
      desc: "The playback speed of the generated video.",
      min: 5,
      max: 60,
      step: 1,
      default: 25,
    },
    {
      label: "Seed",
      name: "seed",
      desc: "The seed to use for the random number generator. Changing this will produce different results.",
      min: 0,
      max: 100000,
      step: 1,
      default: 100,
      long: true,
    },
    {
      label: "Frames",
      name: "frames",
      desc: "The total number of frames generated in the output clip.",
      min: 30,
      max: 204,
      step: 1,
      default: 60,
      long: true,
    },
  ]
}

export const VoiceChoices = {
  "af_sky": "🇺🇸 🚺 Sky",
  "af_kore": "🇺🇸 🚺 Kore",
  "af_nova": "🇺🇸 🚺 Nova",
  "am_adam": "🇺🇸 🚹 Adam",
  "am_echo": "🇺🇸 🚹 Echo",
  "am_eric": "🇺🇸 🚹 Eric",
  "am_liam": "🇺🇸 🚹 Liam",
  "am_onyx": "🇺🇸 🚹 Onyx",
  "am_puck": "🇺🇸 🚹 Puck",
  "bf_emma": "🇬🇧 🚺 Emma",
  "bf_lily": "🇬🇧 🚺 Lily",
  "af_alloy": "🇺🇸 🚺 Alloy",
  "af_aoede": "🇺🇸 🚺 Aoede",
  "af_bella": "🇺🇸 🚺 Bella 🔥",
  "af_heart": "🇺🇸 🚺 Heart ❤️",
  "af_river": "🇺🇸 🚺 River",
  "af_sarah": "🇺🇸 🚺 Sarah",
  "am_santa": "🇺🇸 🚹 Santa",
  "bf_alice": "🇬🇧 🚺 Alice",
  "bm_fable": "🇬🇧 🚹 Fable",
  "bm_lewis": "🇬🇧 🚹 Lewis",
  "af_nicole": "🇺🇸 🚺 Nicole 🎧",
  "am_fenrir": "🇺🇸 🚹 Fenrir",
  "bm_daniel": "🇬🇧 🚹 Daniel",
  "bm_george": "🇬🇧 🚹 George",
  "af_jessica": "🇺🇸 🚺 Jessica",
  "am_michael": "🇺🇸 🚹 Michael",
  "bf_isabella": "🇬🇧 🚺 Isabella"
}

export const LanguageChoices = {
  "Fr": "French",
  "ar": "Arabic",
  "cs": "Czech",
  "de": "Deutsch",
  "en": "English",
  "es": "Spanish",
  "hu": "Hungarian",
  "it": "Italian",
  "ja": "Japanese",
  "ko": "Korean",
  "nl": "Dutch",
  "pl": "Polish",
  "pt": "Portuguese",
  "ru": "Russian",
  "tr": "Turkish",
  "zh-cn": "Chinese"
}